import dayjs from 'dayjs';
import { UserEvent } from './user-event.model';

export class MarqueNotifsLuesEvent extends UserEvent {
  public static NAME = 'MARQUE_NOTIFS_LUE_EVENT';

  constructor(public depuis: dayjs.Dayjs) {
    super(MarqueNotifsLuesEvent.NAME);
  }

  public static hydrate(obj: MarqueNotifsLuesEvent): MarqueNotifsLuesEvent {
    return new MarqueNotifsLuesEvent(dayjs(obj.depuis));
  }
}
